import { render, staticRenderFns } from "./ontick-breadcrumb.component.vue?vue&type=template&id=62c5380a"
import script from "./ontick-breadcrumb.component.vue?vue&type=script&lang=js"
export * from "./ontick-breadcrumb.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports